export default {"src":"/_next/static/media/sweetpotato.7a667a61.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};